var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9D9B98",
    fillRule: "evenodd",
    d: "M19.8 12.05c.1-.2.15-.4.15-.6 0-.2-.05-.35-.15-.45l-4.2-4.35c-.2-.1-.4-.15-.6-.15-.2 0-.4.05-.6.15L10.2 11c-.1.1-.15.25-.15.45s.075.375.225.525a.72.72 0 0 0 .525.225c.2 0 .35-.05.45-.15l3-3v8.7c0 .2.075.375.225.525A.72.72 0 0 0 15 18.5a.72.72 0 0 0 .525-.225.72.72 0 0 0 .225-.525v-8.7l3 3c.1.1.25.15.45.15s.4-.05.6-.15zM15 1.5c-2.4 0-4.65.6-6.75 1.8C6.15 4.5 4.5 6.15 3.3 8.25 2.1 10.35 1.5 12.6 1.5 15c0 2.4.6 4.65 1.8 6.75 1.2 2.1 2.85 3.75 4.95 4.95 2.1 1.2 4.35 1.8 6.75 1.8 2.4 0 4.65-.6 6.75-1.8 2.1-1.2 3.75-2.85 4.95-4.95 1.2-2.1 1.8-4.35 1.8-6.75 0-2.4-.6-4.65-1.8-6.75-1.2-2.1-2.85-3.75-4.95-4.95-2.1-1.2-4.35-1.8-6.75-1.8zM15 0c2.7 0 5.2.675 7.5 2.025A15.126 15.126 0 0 1 27.975 7.5C29.325 9.8 30 12.3 30 15s-.675 5.2-2.025 7.5a15.126 15.126 0 0 1-5.475 5.475C20.2 29.325 17.7 30 15 30s-5.2-.675-7.5-2.025A15.126 15.126 0 0 1 2.025 22.5C.675 20.2 0 17.7 0 15s.675-5.2 2.025-7.5A15.126 15.126 0 0 1 7.5 2.025C9.8.675 12.3 0 15 0zM9.936 20.65c-.197.2-.34.2-.34.6 0 .4.152.4.34.6l.48.15h9.603c.22 0 .414-.075.58-.225a.689.689 0 0 0 .248-.525c0-.2-.083-.375-.249-.525a.836.836 0 0 0-.58-.225h-9.601l-.481.15z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload_icon.cdc1f9b7144645792acfe4b416146227.svg";
export { ForwardRef as ReactComponent };